import React, { Component } from 'react';
import {Field, reduxForm} from 'redux-form';
import PropTypes from 'prop-types';
import {renderCheckbox, renderTextField} from "../../utils/form";

class UserProfileForm extends Component {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired
  };

  render() {
    return (
      <form onSubmit={this.props.handleSubmit}>
        <Field
          component={renderTextField}
          name="firstName"
          type="text"
          placeholder="First Name"
          required={true}
        />
        <Field
          component={renderTextField}
          name="lastName"
          type="text"
          placeholder="Last Name"
          required={true}
        />
        <Field
          component={renderTextField}
          name="email"
          type="text"
          placeholder="Email"
          required={true}
        />
        <Field
          component={renderCheckbox}
          name="receiveNotifications"
          label="Receive Email Notifications"
        />
        <Field
          component={renderTextField}
          name="phoneNumber"
          type="text"
          placeholder="Phone Number"
          required={true}
        />
        <button type="submit" className="btn btn-success">
          Submit
        </button>
      </form>
    );
  }
}

export default reduxForm({
  form: 'userProfileForm'
})(UserProfileForm);
